import { render, staticRenderFns } from "./DispatchWaybillDetailsLoadTable.vue?vue&type=template&id=72bb9204&scoped=true&"
import script from "./DispatchWaybillDetailsLoadTable.vue?vue&type=script&lang=js&"
export * from "./DispatchWaybillDetailsLoadTable.vue?vue&type=script&lang=js&"
import style0 from "./DispatchWaybillDetailsLoadTable.vue?vue&type=style&index=0&id=72bb9204&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb9204",
  null
  
)

export default component.exports